<template>
    <div>
        <general-header v-bind:content="{header: 'Privacy Policy', subheader: '', buttonText: 'Get Started', buttonIcon: '', buttonPosition: '', to: ''}"></general-header>

        <section class="privacy">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <p>When you perform actions on Best Meta, such as choosing a category or conducting a product search, some information is automatically collected. Examples of these pieces of information are your ip address, type of connection, browser type, incoming and outgoing connections, etc. At the time of collection, we are not associating the information with any identified person to do anything else other then what is needed to run Best Meta.</p>

                        <p>We may show ads on Best Meta. The parties that show these ads use information about your visit to this site and other sites to show you advertisements about goods/services that are relevant to your interests.</p>

                        <p>If you do not agree with the terms found in our privacy policy or our terms of service, then please do not use Best Meta.</p>
                    </div>
                </div>
            </div>
        </section>

        <general-header
            v-bind:content="{
                header: 'Looking for the best products?',
                subheader: '',
                buttonText: 'Search',
                buttonIcon: 'search',
                iconPosition: 'left',
                to: 'home'
            }">
        </general-header>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'privacy',
    computed: {
        ...mapGetters({
            user: 'user/user'
        })
    },
    mounted () {
    }
}
</script>

<style lang="scss" scoped>

    .privacy {
        padding: 45px 0;
    }

</style>
